import React, { useEffect, useState } from 'react';
import {
	Grid,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Box,
	Divider,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { CountryList } from '../../../../components/CountryList';

import { TagList } from '../../../../components/TagList';
import { useSelector } from 'react-redux';
import Dropdown from 'src/components/Dropdown';
import MultiSelect from 'src/components/MultiSelect';

import AirasiaDataForm from '../../../../components/Forms/AirasiaDataForm';
import ImageUploadForm from '../../../../components/Forms/ImageUploadForm';
import Input from 'src/components/Input';
// import DateTimeInput from 'src/components/DateTimeInput';
// import TimeInput from 'src/components/TimeInput';

// import moment from 'moment';

const DEFAULT_DESIGN = 'https://via.placeholder.com/300x300';

const INIT_FORM_DATE = {
	title: '',
	imageUrl: '',
	country: '',
	price: '',
	consumerPrice: '',
	discountAmount: '',
	discountPercentage: '',
	categories: [],
	labels: [],
	merchant: null,
	validTermDd: '',
	limitIssueQty: '',
	voucherTypeId: '',
	precautions: '',
	userGuide: '',
};

const INIT_ERRORS = {
	title: '',
	price: '',
	consumerPrice: '',
	validTermDd: '',
	merchant: '',
	voucherTypeId: '',
	precautions: '',
	userGuide: '',
};

const convertTextToMarkup = (value) => {
	return value.replace(/\n/g, '<br/>'); // eslint-disable-line
};

const convertHtmlToText = (value) => {
	const regex = /<[\/]?br\s*[\/]?>/gi; // eslint-disable-line
	return value.replace(regex, '\n');
};

const AddSkuModal = ({ isVisible, onClose, onCreate, existingFormData, labels, country }) => {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const isUpdate = Object.keys(existingFormData || {}).length !== 0;

	const categories = useSelector((state) => state.skuList.categories);
	const merchants = useSelector((state) => state.skuList.merchants);
	const voucherTypes = useSelector((state) => state.skuList.voucherTypes);

	const [errors, setErrors] = useState(INIT_ERRORS);
	const [formData, setFormData] = useState({ ...INIT_FORM_DATE, country: country });
	const [backgroundImage, setBackgroundImage] = useState(DEFAULT_DESIGN);
	const [image, setImage] = useState(null);
	const [selectedProductLabels, setSelectedProductLabels] = useState([]);
	const [airasiaData, setAirasiaData] = useState({});
	const [filteredLabels, setFilteredLabels] = useState([]);
	const [hasError, setHasError] = useState(false);
	const [defaultMerchant, setDefaultMerchant] = useState(null);
	const [categoryList, setCategoryList] = useState([]);

	useEffect(() => {
		if (!country) return;
		setFormData((prevState) => ({
			...prevState,
			country,
		}));
	}, [country]);

	useEffect(() => {
		if (voucherTypes && voucherTypes.length > 0 && !isUpdate) {
			const airasiaVoucher = voucherTypes.find((voucherType) =>
				voucherType?.title.toLowerCase().includes('airasia')
			);
			const id = airasiaVoucher ? airasiaVoucher.id : voucherTypes[0].id;

			setFormData((prevState) => ({
				...prevState,
				voucherTypeId: id,
			}));
		}
	}, [voucherTypes, isUpdate]);

	useEffect(() => {
		if (merchants && merchants.length > 0) {
			const aaMerchant = merchants.find((merchant) =>
				merchant.merchantName.toLowerCase().includes('airasia')
			);
			setDefaultMerchant(existingFormData?.merchant || aaMerchant || null);

			setFormData((prevState) => ({
				...prevState,
				merchant: existingFormData?.merchant || aaMerchant || null,
			}));
		}
	}, [merchants, existingFormData]);

	useEffect(() => {
		const keys = Object.keys(errors);
		let hasValue = true;
		keys.forEach((errKey) => {
			if (formData[errKey] === '' || formData[errKey] === null) {
				hasValue = false;
			}
		});

		setHasError(!hasValue);
	}, [formData, errors]);

	useEffect(() => {
		if (existingFormData && existingFormData.labels && existingFormData.labels.length > 0) {
			setSelectedProductLabels([...existingFormData.labels]);
		}

		if (existingFormData && existingFormData.airasiaData) {
			setAirasiaData({ ...existingFormData.airasiaData });
		}
	}, [existingFormData]);

	useEffect(() => {
		if (selectedProductLabels && selectedProductLabels.length > 0) {
			setFilteredLabels(
				labels.filter(({ id }) => !selectedProductLabels.some((item) => item.id === id))
			);
		} else {
			setFilteredLabels([...labels]);
		}
	}, [selectedProductLabels, labels]);

	useEffect(() => {
		if (existingFormData) {
			const precautions =
				existingFormData && existingFormData.precautions
					? convertHtmlToText(existingFormData.precautions)
					: null;
			const userGuide =
				existingFormData && existingFormData.userGuide
					? convertHtmlToText(existingFormData.userGuide)
					: null;
			// const voucherTypeId = voucherTypes && voucherTypes.length > 0 && isUpdate? voucherTypes[0].id : null

			setFormData({ ...existingFormData, precautions: precautions, userGuide: userGuide });
			setBackgroundImage(existingFormData.imageUrl);
		}
	}, [existingFormData]);

	useEffect(() => {

		if (categories && categories.length > 0) {
			const mappedCategories = [...categories].map((category) => ({
				id: category.id,
				name: category.title,
			}));

			setCategoryList([...mappedCategories]);
		}

	}, [categories])

	const handleCloseModal = (e) => {
		e && e.stopPropagation();
		setSelectedProductLabels([]);
		setBackgroundImage(DEFAULT_DESIGN);
		setErrors(INIT_ERRORS);
		setFormData({ ...INIT_FORM_DATE, country });
		onClose(false);
	};

	const validateField = (name, value) => {
		if (!(name in errors)) {
			return;
		}

		setErrors((prevState) => ({
			...prevState,
			[name]: value ? '' : 'This field is required.',
		}));
	};

	const validateHasError = (name, value) => {
		if (!(name in errors)) {
			return false;
		}

		return !(value !== null && value !== '' && value !== undefined);
	};

	const handleImageChange = (event) => {
		const file = event.target.files[0];

		if (file && file.type && file.type !== 'image/png' && file.type !== 'image/jpeg') {
			setErrors((prevState) => ({
				...prevState,
				image: 'Invalid file type. Only JPEG or PNG is allowed.',
			}));
			return;
		}

		setErrors((prevState) => ({
			...prevState,
			image: '',
		}));

		setImage(event.target.files[0]);

		const reader = new FileReader();

		reader.onload = () => {
			setBackgroundImage(reader.result);
		};

		if (file) {
			reader.readAsDataURL(file);
		}
	};

	const handleInputChange = (event, type) => {
		const { id, value } = event.target;

		setFormData((prevState) => ({
			...prevState,
			[id]: value,
		}));

		if (type === 'number') {
			setErrors((prevState) => ({
				...prevState,
				[id]: value <= 0 ? 'Only accept positive numbers' : '',
			}));
			return;
		}

		validateField(id, value);
	};

	const inputPropsHandlers = {
		onChangeBlur: handleInputChange,
	};

	const handleAirasiaDataForm = (data) => {
		if (!data) return;

		setAirasiaData((prevState) => ({
			...prevState,
			...data,
		}));
	};

	const handlSelectChange = (country) => {
		if (!country) return;
		console.log(country);
		setFormData((prevState) => ({
			...prevState,
			country,
		}));
	};

	const onCreateHandler = () => {
		const items = Object.keys({ ...formData, airAsiaData: { ...airasiaData } });
		let isAllFieldsValidated = true;

		items.forEach((item) => {
			validateField(item, formData[item]);
			if (validateHasError(item, formData[item])) {
				isAllFieldsValidated = false;
			}
		});

		if (!isUpdate && !image) {
			isAllFieldsValidated = false;
			setErrors((prevState) => ({
				...prevState,
				image: 'Image is required',
			}));
		}

		if (isAllFieldsValidated) {
			const payload = {
				...formData,
				image,
				isUpdate,
				precautions: convertTextToMarkup(formData.precautions),
				userGuide: convertTextToMarkup(formData.userGuide),
				airAsiaData: { ...airasiaData, validTermDd: formData.validTermDd },
			};
			onCreate({ ...payload });
			handleCloseModal();
			setImage(null);
		}
	};

	const handleSelectedOptionsChange = (selectedOptions) => {
		// setSelectedProductLabels([...selectedProductLabels, selectedOptions]); //comment this as of now allow only one label till ui support multi
		setSelectedProductLabels([...selectedOptions]);
		setFormData((prevState) => ({
			...prevState,
			labels: [...selectedOptions],
		}));
	};

	const categoriesChangeHandler = (selectedCategories) => {
		setFormData((prevState) => ({
			...prevState,
			categories: [...selectedCategories].map(({ id, name }) => ({ id, title: name })),
		}));
	};

	const changeMerchantHandler = (selectedMerchant) => {
		setFormData((prevState) => ({
			...prevState,
			merchant: {
				id: selectedMerchant.id,
				merchantName: selectedMerchant.name,
			},
		}));
	};

	const changeVoucherTypeHandler = (selectedVoucherType) => {
		// setIsAAVoucher(selectedVoucherType && selectedVoucherType.name.includes('Airasia'));
		setFormData((prevState) => ({
			...prevState,
			voucherTypeId: selectedVoucherType.id,
		}));
	};

	return (
		<Dialog
			open={isVisible}
			onClose={handleCloseModal}
			fullScreen={fullScreen}
			scroll="paper"
			maxWidth={'sm'}
		>
			<DialogTitle id="scroll-dialog-title" onClose={onClose}>
				New Gift Product
			</DialogTitle>
			<DialogContent dividers>
				<Box sx={{ flexGrow: 1 }}>
					<Grid container spacing={3} columns={12} direction="column">
						<ImageUploadForm
							productImage={backgroundImage}
							error={errors.image}
							handleImageChange={handleImageChange}
						/>
						<Grid item md={8} xs={8}>
							<Divider />
						</Grid>
						<Grid item md={7} xs={12}>
							<Box sx={{ flexGrow: 1 }}>
								<Grid container spacing={3}>
									<Grid container item md={12} xs={12}>
										<Input
											{...inputPropsHandlers}
											id="title"
											label="Title"
											value={formData.title}
											error={errors.title}
										/>
									</Grid>
									<Grid container item md={12} xs={12}>
										<CountryList
											disabled
											onChange={handlSelectChange}
											placeholder="Select Country"
											id="country"
											label="Country name"
											variant="filled"
											value={formData.country != null ? formData.country : ''}
											error={!!errors.title}
										/>
									</Grid>
									<Grid item container spacing={2}>
										<Grid item md={6} xs={6}>
											<Input
												{...inputPropsHandlers}
												id="price"
												label="Sales Price"
												type="number"
												value={formData.price}
												error={errors.price}
											/>
										</Grid>
										<Grid item md={6} xs={6}>
											<Input
												{...inputPropsHandlers}
												id="consumerPrice"
												label="Original Price"
												type="number"
												helperText={formData.consumerPrice}
												error={errors.consumerPrice}
											/>
										</Grid>
									</Grid>
									{isUpdate && (
										<Grid item container spacing={2}>
											<Grid item md={6} xs={6}>
												<Input
													disabled
													id="discountAmount"
													label="Discount Amount"
													type="number"
													value={formData.discountAmount}
													error={errors.discountAmount}
												/>
											</Grid>
											<Grid item md={6} xs={6}>
												<Input
													disabled
													id="discountPercentage"
													label="Discount Percentage"
													type="number"
													value={formData.discountPercentage}
													error={errors.discountPercentage}
												/>
											</Grid>
										</Grid>
									)}
									<Grid container item>
										<Grid item md={12} xs={12}>
											<MultiSelect
												label="Category"
												onChangeSelect={categoriesChangeHandler}
												options={categoryList}
												value={
													formData &&
													formData.categories &&
													formData.categories.map((category) => ({
														id: category.id,
														name: category.title,
													}))
												}
											/>
										</Grid>
									</Grid>
									<Grid container item>
										<Grid item md={12} xs={12}>
											<Dropdown
												disabled={!!defaultMerchant}
												options={[...merchants].map((merchant) => ({
													id: merchant.id,
													name: merchant.merchantName,
												}))}
												placeholder="Select Merchant"
												id="merchant"
												label="Merchant *"
												value={
													(formData &&
														formData.merchant &&
														formData.merchant.id) ||
													''
												}
												onSelectChange={changeMerchantHandler}
												error={!!errors.merchant}
											/>
										</Grid>
									</Grid>
									<Grid container item>
										<Grid item md={12} xs={12}>
											<TagList
												isMultiple={true}
												options={filteredLabels}
												value={formData && formData.labels}
												onSelectedOptionsChange={
													handleSelectedOptionsChange
												}
											/>
										</Grid>
									</Grid>
									<Grid container item spacing={2}>
										<Grid item md={6} xs={6}>
											<Input
												{...inputPropsHandlers}
												id="validTermDd"
												label="Valid Term Dd"
												type="number"
												value={formData.validTermDd}
												error={errors.validTermDd}
											/>
										</Grid>
										<Grid item md={6} xs={6}>
											<Input
												{...inputPropsHandlers}
												id="limitIssueQty"
												label="Limit Issue Quantity"
												type="number"
												helperText={errors.limitIssueQty}
												value={formData.limitIssueQty}
												error={errors.limitIssueQty}
											/>
										</Grid>
									</Grid>
									<Grid container item>
										<Grid item md={12} xs={12}>
											<Dropdown
												disabled
												options={[...voucherTypes].map((voucherType) => ({
													id: voucherType.id,
													name: voucherType.title,
												}))}
												placeholder="Select Voucher Type"
												id="voucherTypeId"
												label="Voucher Type"
												value={formData && formData.voucherTypeId}
												error={!!errors.voucherTypeId}
												onSelectChange={changeVoucherTypeHandler}
											/>
										</Grid>
									</Grid>
									<AirasiaDataForm
										formData={formData.airAsiaData ? formData.airAsiaData : {}}
										errors={errors}
										hasError={(errors) => console.log(errors)}
										onInputChange={handleAirasiaDataForm}
									/>
									<Grid item md={12} xs={12}>
										<Input
											{...inputPropsHandlers}
											id="precautions"
											label="Terms and Condition"
											type="multi"
											value={formData.precautions}
											error={errors.precautions}
										/>
									</Grid>
									<Grid item md={12} xs={12}>
										<Input
											{...inputPropsHandlers}
											id="userGuide"
											label="User Guide"
											type="multi"
											value={formData.userGuide}
											error={errors.userGuide}
										/>
									</Grid>
									{/* <Grid item md={12} xs={12}>
										<DateTimeInput
											id="date"
											label="Expiry Date"
											value={formData.date || moment()}
											error={errors.date}
											onChange={() => {}}
										/>
									</Grid>
									<Grid item md={12} xs={12}>
										<DateTimeInput
											id="date"
											label="Expiry Date/Time"
											value={formData.date || moment()}
											error={errors.date}
											type="datetime"
											onChange={() => {}}
										/>
									</Grid>
									<Grid item md={12} xs={12}>
										<TimeInput
											id="date"
											label="Expiry Time"
											value={formData.date || moment()}
											error={errors.date}
											type="datetime"
											onChange={() => {}}
										/>
									</Grid> */}
								</Grid>
							</Box>
						</Grid>
					</Grid>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCloseModal}>Cancel</Button>
				<Button
					variant="contained"
					onClick={onCreateHandler}
					disabled={hasError || (!isUpdate && !image)}
				>
					{isUpdate ? 'Update' : 'Create'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddSkuModal;
